import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import Loader from 'react-loader-spinner';
import { useHistory } from "react-router-dom";
import MaterialTable from "material-table";
import moment from 'moment'
import { baseUrl } from '../../../config';
import axiosIntance from '../../../helper/axios';
import { checkAccess, FEATURES } from '../../../library/auth'
import { clickColor, inArray } from '../../../library/util';
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: 'white'
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    background: isFocused
      ? 'lightblue'
      : isSelected
        ? '#2a7bc0'
        : undefined,
    zIndex: 1
  }),
  menu: base => ({
    ...base,
    zIndex: 100
  })
}

function VipRetention() {

  const history = useHistory();
  if (localStorage.getItem('isLogin') === "false" || localStorage.getItem('isLogin') == null ||
      !checkAccess(FEATURES.vip_report)) {
    history.push('/')
  }

  const [reportData,setReportData]=useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedrowList,setSelectedRowList]=useState([]);
  const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date(Date.now()).setHours(23,59,0,0));
  const [message, setMessage] = useState('')
  const [loader,setLoader]=useState(false);
  const [groupBy, setGroupBy] = useState('');

  const groupByOptions = [
    { value: 'vip_price', label: 'VIP Price' },
    { value: 'date_of_sale', label: 'VIP Sale Date' },
  ];
  // // fields with dynamic titles
  // const [title_projected_rebill_revenue,setTitleProjectedRebillRevenue]=useState('Projected Rebill Revenue');
  // const [title_estimated_billable_revenue,setTitleEstimatedBillableRevenue]=useState('Estimated Billable Revenue');

  useEffect(() => {
    return () => {
      console.log('un subscribe')
    }
  }, []);

  const handleChangeGroupBy = (target) => {
    if (target) {
      setGroupBy(target.value);
    } else {
      setGroupBy('');
    }
  }

  const handleSignOut = () => {
    window.localStorage.setItem('isLogin', false);
    history.push('/');
  }

  const handleSelectRow = (selectedRow) => {
    if (!inArray(selectedRow.tableData.id, selectedrowList)) {
      setSelectedRowList(oldArray => [...oldArray, selectedRow.tableData.id]);
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
    } else {
      setSelectedRow(500000)
      setSelectedRowList([])
    }
  }

  const handleRunReport = () => {
    setMessage('');

    if (startDate == null) {
      setMessage('Date must not be blank')
      return false;
    }

    setLoader(true);

    axiosIntance.get(`${baseUrl}/reports/vip/retention`
      + `?startdate=${moment(startDate).format('YYYY-MM-DD HH:mm:ss')}`
      + `&enddate=${moment(endDate).format('YYYY-MM-DD HH:mm:ss')}`
      + `&group=${groupBy}`
    , {}).then(response => {
      setLoader(false);
      if (response.data.result.length > 0) {
        // setTitleProjectedRebillRevenue(`Projected Rebill Revenue ${response.data.result[0].projected_rebill_revenue_note}`);
        // setTitleEstimatedBillableRevenue(`Estimated Billable Revenue ${response.data.result[0].projected_rebill_revenue_note}`);
        setReportData(response.data.result);
      } else {
        // setTitleProjectedRebillRevenue('Projected Rebill Revenue');
        // setTitleEstimatedBillableRevenue('Estimated Billable Revenue');
        setReportData([]);
      }
    }).catch(error => {
      setLoader(false);
      setMessage('Something went wrong');
    });
  }

  const handleResetFilter = () => {
    setMessage('');
    setEndDate(new Date(Date.now()));
    setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    setGroupBy('');
    setReportData([]);
  }

  const renderPercent = field => data => 
    data[field] !== undefined ? `${(100 * data[field]).toFixed(1)}%`  : '';

  const renderCurrency = field => data => 
    data[field] !== undefined ? `$${data[field].toFixed(2)}`  : '';

  const renderToFixed2 = field => data => 
    data[field] !== undefined ? `${data[field].toFixed(2)}`  : '';

  return (
    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />

      <div className='errorMsg'>{message}</div>

      <section id="content-wrapper">
        <label>Start Date</label>
        <label className='endDateStyle'>End Date</label>
        <label style={{marginLeft: '100px'}}>Group By</label>
        <div className="input-bar">
          <div className="input-bar-item width100">

            <DatePicker
              dateFormat="yyyy-MM-dd HH:mm"
              selected={startDate}
              className='width140x'
              onChange={(date) => setStartDate(date)}
              placeholder='Start Date'

              showTimeSelect
              timeFormat="p"
              timeIntervals={15}
            />

          </div>

          &nbsp;&nbsp;&nbsp;

          <div className="input-bar-item width100">

            <DatePicker
              dateFormat="yyyy-MM-dd HH:mm"
              selected={endDate}
              className='width140x'
              onChange={(date) => setEndDate(date)}
              placeholder='End Date'

              showTimeSelect
              timeFormat="p"
              timeIntervals={15}

            />

          </div>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

          <div className="input-bar-item width100">

            <Select
              components={animatedComponents}
              onChange={e => handleChangeGroupBy(e)}
              maxMenuHeight={250}
              isClearable={true}
              isSearchable={false}
              className="widthSelectInput"
              classNamePrefix="select"
              styles={colourStyles}
              options={groupByOptions}
            />

          </div>
          &nbsp;&nbsp;&nbsp;
        
          <div className="input-bar-item">
            <button type="button" onClick={handleRunReport} className="btn btn-primary">Run Report</button>
          </div>

          <div className='input-bar-item'>
            <button type="button" onClick={handleResetFilter} className="btn btn-primary">Reset</button>
          </div>

        </div>

        {loader

          ? <div className='loaderDiv'>
            <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" />
          </div>
          
          : <MaterialTable
            onRowClick={((evt, selectedRow) => handleSelectRow(selectedRow))}

            columns={[
              { title: "Offer/Cycle", field: "group" },
              
              { title: "FE sales", field: "fe_sales" },
              { title: "Sales", field: "sales", cellStyle: {fontWeight: 'bold'}},
              { title: "CVR", field: "cvr", render: renderPercent('cvr'), cellStyle: {fontWeight: 'bold'} },
              { title: "Retention Rate", field: "retention_rate", render: renderPercent('retention_rate'), cellStyle: {fontWeight: 'bold'} },
              { title: "Cycles AVG", field: "cycles_avg", render: renderToFixed2('cycles_avg') },
              { title: "AOV", field: "aov", render: renderCurrency('aov'), cellStyle: {fontWeight: 'bold'} },
              { title: "LTV", field: "ltv", render: renderCurrency('ltv'), cellStyle: {fontWeight: 'bold'} },
              { title: "Cycle Value per FE", field: "ltv_add", render: renderCurrency('ltv_add'), cellStyle: {fontWeight: 'bold'} },
              { title: "Net Cycle Value per FE", field: "ltv_add_net", render: renderCurrency('ltv_add_net'), cellStyle: {fontWeight: 'bold'} },
              { title: "Refund $ per FE", field: "refund_amount_avg", render: renderCurrency('refund_amount_avg'), cellStyle: {fontWeight: 'bold'} },
              { title: "CB $ per FE", field: "cb_amount_avg", render: renderCurrency('cb_amount_avg'), cellStyle: {fontWeight: 'bold'} },
              { title: "Net LTV of VIPs", field: "vip_ltv_net", render: renderCurrency('vip_ltv_net'), cellStyle: {fontWeight: 'bold'} },
              { title: "Declines", field: "declines" },
              { title: "Approval rate", field: "approval_rate", render: renderPercent('approval_rate'), cellStyle: {fontWeight: 'bold'} },
              { title: "Refunds", field: "refunds" },
              { title: "Refunds %", field: "refunds_perc", render: renderPercent('refunds_perc'), cellStyle: {fontWeight: 'bold'} },
              { title: "CBs", field: "cbs" },
              { title: "CBs %", field: "cbs_perc", render: renderPercent('cbs_perc'), cellStyle: {fontWeight: 'bold'} },
              { title: "Pre-rebill Initial VIP Refunds", field: "vip_refunds_prerebill" },
              { title: "Pre-rebill Initial VIP Refunds %", field: "vip_refunds_prerebill_perc", render: renderPercent('vip_refunds_prerebill_perc'), cellStyle: {fontWeight: 'bold'} },
              // { title: "This cycle Initial VIP Refunds", field: "vip_refunds_this_cycle" },
              { title: "Initial VIP Refunds on the Same Day", field: "vip_refunds" },
              { title: "Initial VIP Refunds on the Same Day %", field: "vip_refunds_perc", render: renderPercent('vip_refunds_perc'), cellStyle: {fontWeight: 'bold'} },
              { title: "Initial VIP CBs on the Same Day", field: "vip_cbs" },
              { title: "Initial VIP CBs on the Same Day %", field: "vip_cbs_perc", render: renderPercent('vip_cbs_perc'), cellStyle: {fontWeight: 'bold'} },
              { title: "Subscriptions canceled", field: "subs_canceled" },
              { title: "Cancellation %", field: "subs_canceled_perc", render: renderPercent('subs_canceled_perc'), cellStyle: {fontWeight: 'bold'} },
              { title: "Subscriptions inactivated after declines", field: "subs_declined" },
              { title: "Inactivation after declines %", field: "subs_declined_perc", render: renderPercent('subs_declined_perc'), cellStyle: {fontWeight: 'bold'} },
              { title: "Subscriptions pending next cycle", field: "subs_pending_next_cycle" },
              { title: "Subscriptions pending re-attempt", field: "subs_pending_reattempt" },
            ]}

            data={reportData}

            parentChildData={(row, rows) => rows.find(r => r.key === row.parentKey)}

            title="VIP Retention"

            options={{
              actionsColumnIndex: -1,
              addRowPosition: "first",
              maxBodyHeight: '560px',
              paging: false,
              exportButton: true,
              headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : '',
                fontWeight: (rowData.group === 'Total' ? 'bold' : 'inherit')
              }),
            }}
          />
        }

      </section>

    </div>
  );
}

export default VipRetention
